export default "__VITE_ASSET__BqDM8wEY__"